import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import { getAuth } from 'firebase/auth';

export const ACTION_TYPES = {
  TRANSACTION: {
    REVERT: 'transaction.revert',
    TRANSFER: 'transaction.transfer',
    BATCH_UPDATE: 'transaction.batch_update'
  },
  USER: {
    IMPORT: 'user.import',
    UPDATE: 'user.update',
    BATCH_UPDATE: 'user.batch_update'
  }
};

export const logAdminAction = async (actionType, details) => {
  const auth = getAuth();
  const adminUser = auth.currentUser;

  try {
    const ipResponse = await fetch('https://api.ipify.org?format=json');
    const ipData = await ipResponse.json();

    await addDoc(collection(db, 'adminLogs'), {
      actionType,
      adminEmail: adminUser?.email,
      adminUid: adminUser?.uid,
      details,
      timestamp: serverTimestamp(),
      meta: {
        environment: process.env.NODE_ENV,
        platform: navigator.platform,
        language: navigator.language,
        userAgent: navigator.userAgent,
        ipAddress: ipData.ip || 'unknown'
      }
    });
  } catch (error) {
    await addDoc(collection(db, 'adminLogs'), {
      actionType,
      adminEmail: adminUser?.email,
      adminUid: adminUser?.uid,
      details,
      timestamp: serverTimestamp(),
      meta: {
        environment: process.env.NODE_ENV,
        platform: navigator.platform,
        language: navigator.language,
        userAgent: navigator.userAgent,
        ipAddress: 'unknown'
      }
    });
    console.error('Error logging admin action:', error);
  }
}; 